import { getCalendarConfigWorkingHoursTimeZoneId } from 'owa-calendar-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';

export default () =>
    getFallbackValueIfNull(
        store().workingHoursTimeZoneId,
        getCalendarConfigWorkingHoursTimeZoneId()
    );
